<template>
  <v-card flat class="elevation-0" style="width: 100%;">
    <v-toolbar flat tile light card dense color="transparent">
      <v-layout row align-center>
        <v-icon small pa-0 color="error">mdi-file-pdf</v-icon>
        <v-toolbar-title style="margin-left: 8px;">
          <h6>{{ title }}</h6>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-icon
          class="pr-2"
          v-if="step.pdf.file_upload_url"
          small
          color="#121212"
          >mdi-link-variant</v-icon
        >
        <a
          target="_blank"
          v-if="step.pdf.file_upload_url"
          :href="s3bucket + pdfUrl"
          >file url</a
        >
        <v-spacer></v-spacer>

        <div v-if="(actualPdfState == '1')">
          <v-checkbox
            hide-details
            label="Smart Scaling"
            v-model="smartScaling"
          ></v-checkbox>
        </div>

        <v-btn
          :disabled="loadingState > 0 || actualPdfState == 2"
          flat="flat"
          @click="actionClic(actualPdfState)"
        >
          <v-icon small class="pr-2">
            {{ actionIcon(actualPdfState) }}
          </v-icon>
          {{ actionText(actualPdfState) }}
        </v-btn>
      </v-layout>
    </v-toolbar>
    <v-card-text
      class="pa-0"
      :style="
        'width:100%;height:100%; overflow-y:' +
        (actualPdfState == 3 ? 'hidden; height:90vh;' : 'auto;')
      "
    >
      <v-stepper v-model="actualPdfState">
        <v-stepper-items>
          <v-stepper-content step="1" class="pa-0">
            <div class="document-editor">
              <div
                :id="'pdf_edit_toolbar_' + step.id"
                class="document-editor__toolbar"
              ></div>
              <div class="document-editor__editable-container">
                <div class="document-editor__editable">
                  <ckeditor
                    class="ckeditor_main_container"
                    :editor="editor"
                    v-model="interpolatedBody"
                    :config="editorConfig"
                    @ready="onReady"
                  ></ckeditor>
                  <v-subheader>
                    <v-spacer></v-spacer>
                    <span style="text-align: center;">Footer Preview:</span>
                    <v-spacer></v-spacer>
                  </v-subheader>
                  <div
                    class="ck ck-content ck-editor__editable ck-rounded-corners ck-editor__editable_inline ck-blurred pdf-footer-preview"
                    v-html="interpolatedFooter"
                  ></div>
                </div>
              </div>
            </div>
          </v-stepper-content>
          <v-stepper-content step="2">
            <v-layout
              style="height: 500px;"
              column
              align-center
              class="text-xs-center"
            >
              <v-spacer></v-spacer>
              <v-flex class="text-xs-center">
                <breeding-rhombus-spinner
                  v-if="this.loadingState == 1"
                  style="margin: auto;"
                  class="text-xs-center"
                  :animation-duration="1000"
                  :size="80"
                  color="#1976d2"
                />
                <fulfilling-square-spinner
                  v-if="this.loadingState == 2"
                  style="margin: auto;"
                  class="text-xs-center"
                  :animation-duration="4000"
                  :size="80"
                  color="#1976d2"
                />
                <h2 style="color: #555;" class="pt-4">
                  {{ getLoadingMessage() }}
                </h2>
              </v-flex>
              <v-spacer></v-spacer>
            </v-layout>
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
      <v-flex style="height: inherit;" v-if="actualPdfState == 3" class="pa-0">
        <!-- DISPLAY PDF IF ALREADY UPLOADED -->

        <object
          :key="pdfUrl"
          v-if="pdfUrl"
          :data="s3bucket + pdfUrl"
          style="height: 90vh;"
          width="100%"
          type="application/pdf"
        >
          <embed
            height="980"
            width="100%"
            :src="
              'http://docs.google.com/gview?url=' +
              s3bucket +
              pdfUrl +
              '&embedded=true'
            "
          />
        </object>

        <!-- HIDDEN, USED TO GENERATE PDF -->
      </v-flex>
    </v-card-text>

    <v-card-actions style="display: block;" class="pa-0">
      <v-stepper v-model="actualPdfState">
        <v-stepper-header>
          <v-stepper-step
            :complete="loadingState == 0"
            :editable="loadingState == 0"
            step="1"
            >Edit PDF</v-stepper-step
          >

          <v-divider></v-divider>

          <v-stepper-step
            complete-icon="backup"
            :complete="actualPdfState == 3"
            step="2"
            >Generation & Upload</v-stepper-step
          >

          <v-divider></v-divider>

          <v-stepper-step
            :editable="step.pdf.file_upload_url != ''"
            :complete="step.pdf.file_upload_url != ''"
            edit-icon="mdi-file-pdf"
            complete-icon="mdi-file-pdf"
            step="3"
            >Final PDF Preview</v-stepper-step
          >
        </v-stepper-header>
      </v-stepper>
    </v-card-actions>
  </v-card>
</template>

<script>
import uploader from "../../mixins/uploader";
import UPDATE_PDF from "../../graphql/pdf/update.gql";
import PDF_CONTENT from "../../graphql/pdf/content.gql";
import PDF_BLOB from "../../graphql/pdf/blob.gql";
import gql from "graphql-tag";
import { mapGetters } from "vuex";
import { BreedingRhombusSpinner, FulfillingSquareSpinner } from "epic-spinners";

import ClassicEditor from "@ckeditor/ckeditor5-editor-classic/src/classiceditor";
import CKEditor from "@ckeditor/ckeditor5-vue";
import EssentialsPlugin from "@ckeditor/ckeditor5-essentials/src/essentials";
//import AutoformatPlugin from "@ckeditor/ckeditor5-autoformat/src/autoformat";
import BlockQuotePlugin from "@ckeditor/ckeditor5-block-quote/src/blockquote";
import BoldPlugin from "@ckeditor/ckeditor5-basic-styles/src/bold";
import ItalicPlugin from "@ckeditor/ckeditor5-basic-styles/src/italic";
import LinkPlugin from "@ckeditor/ckeditor5-link/src/link";
import Underline from "@ckeditor/ckeditor5-basic-styles/src/underline";
import Strikethrough from "@ckeditor/ckeditor5-basic-styles/src/strikethrough";
import ListPlugin from "@ckeditor/ckeditor5-list/src/list";
import ParagraphPlugin from "@ckeditor/ckeditor5-paragraph/src/paragraph";
import AlignmentPlugin from "@ckeditor/ckeditor5-alignment/src/alignment";
import Table from "@ckeditor/ckeditor5-table/src/table";
import TableToolbar from "@ckeditor/ckeditor5-table/src/tabletoolbar";
import PasteFromOffice from "@ckeditor/ckeditor5-paste-from-office/src/pastefromoffice";
import MediaEmbed from "@ckeditor/ckeditor5-media-embed/src/mediaembed";
import Font from "@ckeditor/ckeditor5-font/src/font";
import Image from "@ckeditor/ckeditor5-image/src/image";
import ImageToolbar from "@ckeditor/ckeditor5-image/src/imagetoolbar";
import ImageCaption from "@ckeditor/ckeditor5-image/src/imagecaption";
import ImageStyle from "@ckeditor/ckeditor5-image/src/imagestyle";
import ImageUploader from "@ckeditor/ckeditor5-image/src/imageupload";
import ckEditorCustom from "../../plugins/ckEditorCustom";

export default {
  mixins: [uploader],
  components: {
    BreedingRhombusSpinner,
    FulfillingSquareSpinner,
    ckeditor: CKEditor.component,
  },
  props: {
    step: {
      type: Object,
      required: true,
    },
    action_done: {
      type: Boolean,
    },
  },
  data() {
    return {
      s3bucket: process.env.VUE_APP_S3_BUCKET_URL + "/",
      loadingState: 0,
      interpolatedContent: "",
      interpolatedBody: "",
      interpolatedFooter: "",
      smartScaling: true,
      dialog: false,
      pdfFileVersion: Math.round(Math.random() * 1000),
      actualPdfState: 1,
      editor: ClassicEditor,
      editorConfig: {
        plugins: [
          EssentialsPlugin,
          //AutoformatPlugin,
          BoldPlugin,
          ItalicPlugin,
          LinkPlugin,
          ListPlugin,
          ParagraphPlugin,
          BlockQuotePlugin,
          AlignmentPlugin,
          Table,
          TableToolbar,
          PasteFromOffice,
          MediaEmbed,
          Font,
          Image,
          ImageToolbar,
          ImageCaption,
          ImageStyle,
          ImageUploader,
          Underline,
          Strikethrough,
          ckEditorCustom,
        ],
        fontSize: {
          options: [
            "tiny",
            "small",
            "default",
            "big",
            "huge",
            9,
            11,
            13,
            15,
            19,
            21,
            23,
            25,
            27,
            29,
            34,
          ],
        },
        table: {
          contentToolbar: ["tableColumn", "tableRow", "mergeTableCells"],
        },
        image: {
          toolbar: [
            "imageStyle:alignLeft",
            "imageStyle:full",
            "imageStyle:alignRight",
            "imageStyle:headerlogo",
          ],
          styles: [
            "full",
            "alignLeft",
            "alignRight",
            {
              name: "headerlogo",
              icon: "left",
              title: "Header Logo Size",
              className: "pdf-header-logo-size",
            },
          ],
        },
        toolbar: {
          items: [
            "undo",
            "redo",
            "|",
            "fontSize",
            "fontFamily",
            "fontColor",
            "fontBackgroundColor",
            "|",
            "bold",
            "italic",
            "underline",
            "strikethrough",
            "alignment",
            "|",
            "bulletedList",
            "numberedList",
            "blockQuote",
            "|",
            "link",
            "MediaEmbed",
            //"imageUpload",
            "|",
            "insertTable",
          ],
        },
      },
    };
  },
  computed: {
    ...mapGetters("contractStore", ["contract"]),
    pdfUrl: function () {
      return this.step.pdf.file_upload_url + "?v=" + this.pdfFileVersion;
    },
    title() {
      switch (this.actualPdfState) {
        case 1:
        case "1":
          if (this.step.pdf.file_upload_url)
            return "Live Editing - " + this.step.pdf.file_upload_url;
          else return "Live Editing";
        case 2:
        case "2":
          return "Please wait during process...";
        case 3:
        case "3":
          return "Final PDF Preview";
        default:
          return "";
      }
    },
  },
  methods: {
    setPdfUrl(url) {
      this.step.pdf.file_upload_url = url;
    },
    isPdfGenerated() {
      return !!this.step.pdf.file_upload_url;
    },
    pdfTemplateExists() {
      return !!this.step.pdf.pdf_template;
    },
    actionText(state) {
      switch (state) {
        case 1:
        case "1":
          return "Generate & Upload This PDF";
        case 2:
        case "2":
          return "Please wait during process...";
        case 3:
        case "3":
          return "Edit PDF";
        default:
          return "";
      }
    },
    actionIcon(state) {
      switch (state) {
        case 1:
        case "1":
          return "backup";
        case 2:
        case "2":
          return "hourglass-empty";
        case 3:
        case "3":
          return "edit";
        default:
          return state;
      }
    },
    actionClic(state) {
      if (state == 3) this.actualPdfState = 1;
      else this.uploadPdf();
    },
    onReady(editor) {
      const toolbarContainer = document.querySelector(
        "#pdf_edit_toolbar_" + this.step.id
      );
      toolbarContainer.appendChild(editor.ui.view.toolbar.element);
    },
    loadPDF() {
      this.dialog = true;

      this.sendQuery(PDF_CONTENT, { id: this.step.pdf.id })
        .then((data) => {
          this.interpolatedBody = data.pdf.interpolated_body;
          this.interpolatedFooter =
            "<div style='overflow-y: hidden;'>" +
            data.pdf.interpolated_footer +
            "</div>";
          //this.interpolatedContent = this.interpolatedHeader + this.interpolatedBody + this.interpolatedFooter

          if (!this.step.pdf.file_upload_url) {
            // go to edit step
            this.actualPdfState = 1;
          } else {
            // go to preview pdf from cloud
            this.actualPdfState = 3;
          }
        })
        .catch((error) => {
          this.interpolatedBody =
            "<span style='text-align: center; color: #b00020 !important'><b > Sorry, this PDF template is currently unavailable or might have been deleted.</b> </span>";
        });
    },
    uploadPdf() {
      this.loadingState = 1;
      this.actualPdfState = 2;
      var self = this;
      var pdfRootHtml = [];
      let url = process.env.VUE_APP_URL;
      if (url && url.length > 0 && url[url.length - 1] != "/") url += "/";
      pdfRootHtml[0] = `<html><head> <base href='${url}'>`;

      // LOADING CSS BY SEARCHING STYLE ELEMENTS (USED MOSTLY IN DEV)
      pdfRootHtml[0] += "<style>";
      for (const stl in document.getElementsByTagName("style")) {
        if (document.getElementsByTagName("style").hasOwnProperty(stl)) {
          pdfRootHtml[0] +=
            document.getElementsByTagName("style")[stl].innerHTML + " ";
        }
      }
      pdfRootHtml[0] += "</style>";

      //LOADING CSS BY SEARCHING LINK ELEMENTS THAT MAY CONTAIN CSS FILES (IMPORTANT FOR PROD!!)

      for (const stl in document.getElementsByTagName("link")) {
        if (document.getElementsByTagName("link").hasOwnProperty(stl)) {
          pdfRootHtml[0] +=
            document.getElementsByTagName("link")[stl].outerHTML + " ";
        }
      }

      pdfRootHtml[0] +=
        '</head><body><div id="pdf" class="document-editor"><div class="document-editor__editable"><div class="ck ck-reset ck-editor ck-rounded-corners ck-content ck-editor__editable ck-rounded-corners ck-editor__editable_inline ck-blurred ckeditor_main_container">';
      pdfRootHtml[1] = "</div></div></div></body></html>";
      this.sendQuery(PDF_BLOB, {
        id: self.step.pdf.id,
        body: pdfRootHtml[0] + this.interpolatedBody + pdfRootHtml[1],
        footer: pdfRootHtml[0] + this.interpolatedFooter + pdfRootHtml[1],
        smart_scaling: this.smartScaling,
      }).then((data) => {
        this.loadingState = 2;
        var b64pdfstr = data.pdf.blob;
        var binary = atob(b64pdfstr.replace(/\s/g, ""));
        var len = binary.length;
        var buffer = new ArrayBuffer(len);
        var view = new Uint8Array(buffer);
        for (var i = 0; i < len; i++) {
          view[i] = binary.charCodeAt(i);
        }

        var blob = new Blob([view], { type: "application/pdf" });

        const prefix = self.step.expedition
          ? self.step.expedition.contract.name.replace("/", "-") +
            "." +
            self.step.expedition.number
          : self.step.contract.name.replace("/", "-");

        const name = `${prefix} -- ${this.step.step_template.pdf_template.name}.pdf`;

        var file = new File([blob], name, {
          lastModified: new Date(0),
          type: "application/pdf",
        });

        var fun = () => {};
        var success = (uri) => {
          self
            .sendMutation("generated", "pdf", UPDATE_PDF, {
              id: self.step.pdf.id,
              file_upload_url: uri,
            })
            .then((data) => {
              console.log(
                "data.update_pdf.file_upload_url " +
                  data.update_pdf.file_upload_url
              );
              console.log("uri " + uri);
              self.$emit("setPdfUrl", uri);
              self.loadingState = 0;
              self.actualPdfState = 3;
              self.pdfFileVersion = Math.round(Math.random() * 1000);
              self.step.pdf.file_upload_url = data.update_pdf.file_upload_url;
            });
        };
        /* Upload in bucket here */
        this.loadingState === 2;
        this.process("uploadedPdf", file, fun, fun, fun, fun, fun, success);
      });
    },
    getLoadingMessage() {
      if (this.loadingState === 1) return "Building PDF...";
      else if (this.loadingState === 2) return "Uploading...";
      return "";
    },
  },
  created: function () {
    this.loadPDF();
  },
};
</script>

<style lang="stylus" scoped>
td {
  cursor: pointer;
}

.pdfbar {
}
</style>

<style>
.v-menu__content {
  z-index: 500 !important;
}
</style>
